<div class="layout-wrapper" [ngClass]="{
        'layout-wrapper-menu-active':sidebarActive
    }">

    <div class="crossfade">
        <div style="
        width: 100%;
        height: 100vh;
        position: absolute;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;">
        </div>
    </div>


    <app-header [isLoggedIn]="isLoggedIn"></app-header>

    <table class="root-table">
        <thead>
            <tr>
                <td>
                    <div class="page-header-space"></div>
                </td>
            </tr>
        </thead>

        <tbody>
            <tr>
                <td>
                    <div class="layout-content">
                        <router-outlet></router-outlet>
                    </div>
                </td>
            </tr>
        </tbody>

        <tfoot>
            <tr>
                <td>
                    <div class="page-footer-space"></div>
                </td>
            </tr>
        </tfoot>
    </table>

</div>

<p-toast key="info" [style]="{marginTop: '80px'}"></p-toast>
<p-toast key="info-large" position="center" styleClass="info-large-toast"></p-toast>
<p-toast key="modal" position="center" [baseZIndex]="5000">
    <ng-template let-message pTemplate="message">
        <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-text-center">
                <i class="pi pi-exclamation-triangle" style="font-size: 3em"></i>
                <h3>{{message.summary}}</h3>
                <p>{{message.detail}}</p>
            </div>
            <div class="p-field p-col-12 p-md-4" *ngIf="message.data.onConfirm">
                <button type="button" pButton (click)="message.data.onConfirm()"
                    [label]="message.data.confirmBtnLabel || 'Yes'" class="p-button-success"></button>
            </div>
            <div class="p-field p-col-12 p-md-8" *ngIf="message.data.onReject">
                <button type="button" pButton (click)="message.data.onReject()"
                    [label]="message.data.rejectBtnLabel || 'No'" class="p-button-danger"></button>
            </div>
        </div>
    </ng-template>
</p-toast>